var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrizes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_109_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_110_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_138_",
    style: {
      fill: "#BF720D"
    },
    cx: 65,
    cy: 135,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_169_",
    style: {
      fill: "#BF720D"
    },
    cx: 50,
    cy: 80,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_197_",
    style: {
      fill: "#FFFFFF"
    },
    cx: 50,
    cy: 80,
    r: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_221_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_222_",
    style: {
      fill: "#FF9811"
    },
    cx: 255,
    cy: 135,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_223_",
    style: {
      fill: "#FF9811"
    },
    cx: 270,
    cy: 80,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_224_",
    style: {
      fill: "#FFFFFF"
    },
    cx: 270,
    cy: 80,
    r: 20
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_225_",
    style: {
      fill: "#FFDA44"
    },
    d: "M50,30v20c0,60.752,49.249,110,110,110s110-49.248,110-110V30H50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_226_",
    style: {
      fill: "#FF9811"
    },
    d: "M160,30H50v20c0,60.752,49.249,110,110,110V30z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_41_",
    style: {
      fill: "#FFDA44"
    },
    points: "160,210 190,210 220,270 160,270  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_40_",
    x: 160,
    y: 100,
    style: {
      fill: "#FFDA44"
    },
    width: 30,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_39_",
    x: 130,
    y: 100,
    style: {
      fill: "#FF9811"
    },
    width: 30,
    height: 120
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_38_",
    style: {
      fill: "#FF9811"
    },
    points: "130,210 160,210 160,270 100,270  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_227_",
    x: 90,
    y: 260,
    style: {
      fill: "#BF720D"
    },
    width: 70,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_228_",
    x: 160,
    y: 260,
    style: {
      fill: "#FF9811"
    },
    width: 70,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_229_",
    x: 120,
    y: 290,
    style: {
      fill: "#FF9811"
    },
    width: 40,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_230_",
    x: 160,
    y: 290,
    style: {
      fill: "#FFDA44"
    },
    width: 40,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_231_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_232_",
    x: 50,
    style: {
      fill: "#BF720D"
    },
    width: 110,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_233_",
    x: 160,
    style: {
      fill: "#FF9811"
    },
    width: 110,
    height: 30
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizes);
export default __webpack_public_path__ + "static/media/prizes.5ed53b2ed49668de8e0036f5cb09c2ff.svg";
export { ForwardRef as ReactComponent };